import Component from '../../../lib/component';
// import '../base-form/base-form.scss';
import './post-message-get-user.scss';
import template from './post-message-get-user.html'
import {PMAPI} from "../../../lib/postmsg";
import {HTTP} from "../../../lib/http";
let config = {
    template: template,
    data: {
        departmentData: {},
        choosedUsers: [],
    },
    actions: {
        init(){
            let _this = this;
            if(this.data.history){
                this.el.find('.ui-history').css('visibility','visible');
            }
            this.el.find('.ui-width').css('width', this.data.width);
            this.el.find('.ui-width').attr('title', this.data.value);
            this.el.find('.ui-width').attr('disabled', true);
            this.el.find('.ui-width').css('background', 'rgb(235,235,228)');
            if(!this.data.is_view){
                this.el.find('.ui-selector').css('visibility','visible').addClass('icon-fl');
            }
            this.actions.getDepartmentData();
            // this.el.find('.ui-selector').css('visibility','visible').addClass('icon-fl');
            // //回显
            // if (_this.data.value || _this.data.value==0) {
            //     _this.el.find(".search").val(_this.data.value);
            // } else {
            //     _this.el.find(".search").val('');
            // }


        },
        // changeValue:function(val){
        //     this.data.value = val;
        //     this.events.changeValue(this.data)
        // },
        /**
         * 打开选择人员列表
         */
        // openGetUsers() {
        //     PMAPI.openDialogByIframe('/iframe/PostMessageGetUsers',{
        //         width: 540,
        //         height: 600,
        //         maxable: false,
        //         title: '选择人员'
        //     },{
        //         data:this.data.departmentData,
        //         choosedUsers:this.data.choosedUsers
        //     }).then(res=>{
        //         if(!res.onlyclose){
        //             this.data.choosedUsers =res.choosedUsers.map((item) => {
        //                 return item.id;
        //             });
        //             this.data.choosedUsersName = res.choosedUsers.map((item) => {
        //                 return item.name;
        //             });

        //             this.data.isHr = res.isHr;
        //             this.data.depUserIds = res.depUserIds;
        //             this.actions.showChoosedUsersName(this.data.choosedUsersName);
        //             console.log('openGetUsers', this.data.dfield, this.data.choosedUsers);
        //             this.events.selectPostMessageUserCb(this.data.dfield, this.data.choosedUsers);
        //         }
        //     })
        // },
        /**
         *收件人不足五人的情况下，就全部显示人名，超过五个人，就显示前五个人的人名加上收件人人数
         */
        showChoosedUsersName (choosedUsersName) {
            let showChoosedUsersName = choosedUsersName;
            let count = choosedUsersName.length;
            if(count > 5) {
                showChoosedUsersName = choosedUsersName.slice(0,5)
                this.el.find('.recipients').val(showChoosedUsersName+`   共${count}人`)
            }else{
                this.el.find('.recipients').val(showChoosedUsersName)
            }

        },
        getDataService: function(){
            return HTTP.postImmediately('/get_department_tree/');
        },
        getDepartmentData: function () {
            HTTP.postImmediately('/get_department_tree/').then((res) => {
                console.log('getDepartmentData')
                this.data.departmentData = res.data
                this.actions.setValue();
            })
        },
        setValue: function(){
            let _data = this.data;
            if(this.data.value && this.data.value.length > 0){
                this.data.choosedUsers = this.data.value;
                if(!$.isEmptyObject(_data.departmentData)){
                    let obj = _data.departmentData.department2user;
                    let userIds = this.data.value;
                    let users = [];
                    $.each(userIds, function(i, id){
                        $.each(obj, function(key, val){
                            if(val[id] !== undefined){
                                users.push(val[id]['name'])
                            }
                        })
                    });
                    this.actions.showChoosedUsersName(users)
                }
            }
        }
    },
    binds: [
        {
            event: 'click',
            selector: '.ui-history',
            callback: function () {
                this.events.emitHistory(this.data)
            }
        },
        {
            event: 'mousedown',
            selector: 'input',
            callback: function () {
                this.el.find("input").css({
                    "border": "1px solid rgb(169, 210, 255)",
                });
            }
        },
        {
            event: 'mouseleave',
            selector: 'input',
            callback: function () {
                this.el.find("input").css({
                    "border": "1px solid rgb(226, 226, 226)",
                });
            }
        },{
            event: 'click',
            selector: '.ui-selector',
            callback: function(){
                this.events.openGetUsers(this.data, this.actions.showChoosedUsersName);
            }
        },
    ],
    // beforeRender(){
    //     this.actions.getDepartmentData();
    // },
    afterRender() {
        this.actions.init();
    },


    beforeDestory() {
        this.el.off();
    }
};
let PostMessageGetUser = Component.extend(config);
export default PostMessageGetUser


// WEBPACK FOOTER //
// app/components/form/post-message/post-message-get-user.js